var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 640",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M497.5 177L337.5 337C328.1 346.4 312.9 346.4 303.6 337L143.5 177C134.1 167.6 134.1 152.4 143.5 143.1C152.9 133.8 168.1 133.7 177.4 143.1L320.4 286.1L463.4 143.1C472.8 133.7 488 133.7 497.3 143.1C506.6 152.5 506.7 167.7 497.3 177zM497.5 369L337.5 529C328.1 538.4 312.9 538.4 303.6 529L143.5 369C134.1 359.6 134.1 344.4 143.5 335.1C152.9 325.8 168.1 325.7 177.4 335.1L320.4 478.1L463.4 335.1C472.8 325.7 488 325.7 497.3 335.1C506.6 344.5 506.7 359.7 497.3 369z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDown);
export default __webpack_public_path__ + "static/media/icon_down.3b5b0b9e48546fd5640fbe6fcf583a9b.svg";
export { ForwardRef as ReactComponent };